export const AOL_CORPORATE = 'corporate'
export const AOL_EMPLOYMENT = 'employment'
